import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import avatar from "../../assets/images/avatar.png";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import call_micro_icon from "../../assets/icons/call_micro_icon.png";
import mail_micro_icon from "../../assets/icons/mail_micro_icon.png";
import white_calender_icon from "../../assets/icons/white_calender_icon.png";
import theme_icon from "../../assets/icons/theme_icon.png";
import font_icon from "../../assets/icons/font_icon.png";
import push_notification_icon from "../../assets/icons/push_notification_icon.png";
import sms_icon from "../../assets/icons/sms_icon.png";
import email_setting_icon from "../../assets/icons/email_setting_icon.png";
import gear_icon from "../../assets/icons/gear_icon.png";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComponents/Sidebar";

const AdminProfile = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            className="object-contain"
            alt="hamburger"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Sidebar />}
        </div>
      </div>

      <div className="ml-4 mt-8 border rounded-lg p-2 w-[90%] ">
        <div className="flex items-center justify-between profile-one">
          <div className="flex items-center w-full">
            <img
              src={avatar}
              alt="profile image"
              className="w-8 rounded-full"
            />
            <p className="text-[18px] font-bold ml-2">
              Mohit Shah{" "}
              <span className="text-[#333333] font-normal italic">
                (senior manager)
              </span>
            </p>
          </div>
          <div className="flex items-center text-[#828282] text-[16px] w-[80%]">
            <img src={call_micro_icon} alt="call icon" />
            <p className="ml-1">+91-7856632923</p>
          </div>
          <div className="flex items-center  text-[#828282] text-[16px] w-[80%]">
            <img src={mail_micro_icon} alt="mail" />
            <p className="ml-1">praveen@gmail.com</p>
          </div>
          <div className="flex items-center  text-[#828282] text-[16px] w-[80%]">
            <img src={white_calender_icon} alt="calender" />
            <p className="ml-1">05th December 1988</p>
          </div>
        </div>

        <div className="flex justify-center mt-4 underline text-[#2F80ED] text-[16]">
          <p className="cursor-pointer">Edit</p>
        </div>
      </div>

      {/* Theme , Fonts , Language */}

      {/* Theme */}
      <div className="ml-4 mt-4 border flex p-4 rounded-lg w-[90%] profile-one">
        <Link
          to="/profile/theme"
          className="flex items-start cursor-pointer w-[30%] profile-section-width"
        >
          <img src={theme_icon} alt="theme" className="w-8 object-contain" />
          <div className="ml-2">
            <p className="text-[18px] font-bold">Theme</p>
            <p className="text-[14px] italic text-[#828282] mt-3">
              Theme your way for a personalized touch{" "}
            </p>
          </div>
        </Link>

        <div className="vl"></div>

        {/* Fonts */}
        <Link
          to="/profile/fonts"
          className="flex items-start cursor-pointer w-[30%] profile-section-width ml-4"
        >
          <img src={font_icon} alt="theme" className="w-7 object-contain" />
          <div className="ml-2">
            <p className="text-[18px] font-bold">Fonts</p>
            <p className="text-[14px] italic text-[#828282] mt-3">
              Style your app with the perfect font
            </p>
          </div>
        </Link>

        <div className="vl"></div>

        {/* Language */}
        <Link
          to="/profile/language"
          className="flex items-start cursor-pointer w-[30%] profile-section-width ml-4"
        >
          <img src={theme_icon} alt="theme" className="w-8 object-contain" />
          <div className="ml-2">
            <p className="text-[18px] font-bold">Language</p>
            <p className="text-[14px] italic text-[#828282] mt-3">
              Speak your language, personalize your experience
            </p>
          </div>
        </Link>
      </div>

      {/*Notification , SMS , Email */}

      {/* Notification */}
      <div className="ml-4 mt-4 border flex p-4 rounded-lg w-[90%] profile-one">
        <Link
          to="/profile/notifications"
          className="flex items-start cursor-pointer w-[30%] profile-section-width"
        >
          <img
            src={push_notification_icon}
            alt="theme"
            className="w-6 object-contain"
          />
          <div className="ml-2">
            <p className="text-[18px] font-bold">Push Notification</p>
            <p className="text-[14px] italic text-[#828282] mt-3">
              Stay in the loop - tailor your notifications, your way
            </p>
          </div>
        </Link>

        <div className="vl"></div>

        {/* SMS Getaway */}
        <Link
          to="/profile/sms"
          className="flex items-start cursor-pointer w-[30%] profile-section-width ml-4"
        >
          <img src={sms_icon} alt="theme" className="w-6 object-contain" />
          <div className="ml-2">
            <p className="text-[18px] font-bold">SMS Getaway</p>
            <p className="text-[14px] italic text-[#828282] mt-3">
              Text your way customize SMS preferences easily
            </p>
          </div>
        </Link>

        <div className="vl"></div>

        {/* Email Setup */}
        <Link
          to="/profile/email"
          className="flex items-start cursor-pointer w-[30%] profile-section-width ml-4"
        >
          <img
            src={email_setting_icon}
            alt="theme"
            className="w-6 object-contain"
          />
          <div className="ml-2">
            <p className="text-[18px] font-bold">Email Setup</p>
            <p className="text-[14px] italic text-[#828282] mt-3">
              Craft your inbox experience customize email settings
            </p>
          </div>
        </Link>
      </div>

      {/* Additional Configuration */}
      <div className="ml-4 my-4 border flex p-4 rounded-lg w-[90%]">
        <Link
          to="/profile/configuration"
          className="flex items-start cursor-pointer"
        >
          <img src={gear_icon} alt="theme" className="w-6 object-contain" />
          <div className="ml-2">
            <p className="text-[18px] font-bold">Additional Configuration</p>
            <p className="text-[14px] italic text-[#828282] mt-3">
              Personalized configurations at your fingertips
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default AdminProfile;
